import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Input, Modal, Radio, Space, Typography } from 'antd'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { ResolveDelayModalStore, type DelayOutcome } from '@/Ship/Stores/ResolveDelayModalStore'

const { Text } = Typography

interface ResolveDelayModalProps {
    delay: any
    open: boolean
    onClose: () => void
    onResolved: () => void
}

export const ResolveDelayModal = observer(({ delay, open, onClose, onResolved }: ResolveDelayModalProps) => {
    const [store] = useState(() => new ResolveDelayModalStore())
    const { showSuccess, showError } = useNotification()

    const handleResolve = async () => {
        const ok = await store.resolve(delay?.uuid, { success: showSuccess, error: showError })
        if (ok) {
            onResolved()
            onClose()
        }
    }

    return (
        <Modal
            open={open}
            title="Результат"
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>Скасувати</Button>,
                <Button
                    key="resolve"
                    type="primary"
                    loading={store.loading}
                    disabled={!store.comment.trim()}
                    onClick={handleResolve}
                >
                    Зберегти результат
                </Button>,
            ]}
        >
            <div style={{ marginBottom: 12 }}>
                <Text type="secondary">Коментар водія: </Text>
                <Text>{delay?.driverComment || '—'}</Text>
            </div>
            <div style={{ marginBottom: 12 }}>
                <Radio.Group
                    value={store.outcome}
                    onChange={e => store.setOutcome(e.target.value as DelayOutcome)}
                >
                    <Space direction="horizontal">
                        <Radio value="resolved">Вирішено</Radio>
                        <Radio value="not_resolved">Не вирішено</Radio>
                    </Space>
                </Radio.Group>
            </div>
            <Input.TextArea
                rows={3}
                placeholder="Обов'язковий коментар диспетчера *"
                value={store.comment}
                onChange={e => store.setComment(e.target.value)}
            />
        </Modal>
    )
})
